import Serializable from "@/core/misc/mixins/Serializable";
import VatRate      from "@/core/types/VatRate";
import Core         from "@/core/Core";

class CompanyTaxSystem extends Serializable {
	public id: number;
	public name: string;
	public vatRate: VatRate | null;

	static fromServer(data: any, result = new CompanyTaxSystem()): CompanyTaxSystem {
		super.fromServer(data, result);

		result.vatRate = Core.utils.hydrate(data.vatRate, VatRate.fromServer);

		return result;
	}

	/** Компания на этой системе по умолчанию плательщик НДС: ОСНО (id 1), УСН (id 3), ЕСХН (id 4) */
	get isVatPayerByDefault(): boolean {
		return this.id === 1 || this.id === 3 || this.id === 4;
	}
}

export default CompanyTaxSystem;